// src/ConfigInput.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ConfigInput.css'; // 确保 CSS 文件的引入

const ConfigInput = () => {
    const navigate = useNavigate();
    const [webApiKey, setWebApiKey] = useState('');
    const [jsApiKey, setJsApiKey] = useState('');
    const [jsSecureKey, setJsSecureKey] = useState('');

    // 在组件加载时读取 localStorage 中的配置
    useEffect(() => {
        const storedConfig = localStorage.getItem('config');
        if (storedConfig) {
            const { webApiKey, jsApiKey, jsSecureKey } = JSON.parse(storedConfig);
            setWebApiKey(webApiKey || '');
            setJsApiKey(jsApiKey || '');
            setJsSecureKey(jsSecureKey || '');
        }
    }, []); // 只在组件加载时执行

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // 将 API 密钥存储在 localStorage
        const config = {
            webApiKey,
            jsApiKey,
            jsSecureKey,
        };
        localStorage.setItem('config', JSON.stringify(config));

        // 跳转到 Amap 组件
        navigate('/map');
    };

    return (
        <div className="config-container">
            <h2>请输入 API 密钥</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>
                        Web API Key:
                        <input
                            type="text"
                            name="webApiKey" // 添加 name 属性以便记住密码
                            value={webApiKey}
                            onChange={(e) => setWebApiKey(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="form-group">
                    <label>
                        JS API Key:
                        <input
                            type="text"
                            name="jsApiKey" // 添加 name 属性以便记住密码
                            value={jsApiKey}
                            onChange={(e) => setJsApiKey(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="form-group">
                    <label>
                        JS Secure Key:
                        <input
                            type="text"
                            name="jsSecureKey" // 添加 name 属性以便记住密码
                            value={jsSecureKey}
                            onChange={(e) => setJsSecureKey(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <button type="submit" className="submit-button">提交</button>
            </form>
        </div>
    );
};

export default ConfigInput;
